import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';

const toolName = 'delete-webhook' as const;

// Define the input schema based on Webflow API docs
const argumentZod = z.object({
  webhook_id: z
    .string()
    .describe('The unique identifier of the webhook to delete'),
});

export const deleteWebhookManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Delete webhook',
  family: 'webhooks',
  llmTool: {
    name: toolName,
    description:
      'Deletes an existing webhook for the current site. This will permanently remove the webhook and stop all future notifications for the specified webhook.',
    inputSchema: argumentZod,
  },
  type: 'server',
  permission: [{resource: 'SiteWebhook', action: 'manage'}],
  confirmBeforeExecuting: true, // Require confirmation for webhook deletion
});

export type DeleteWebhookArgumentType = z.infer<typeof argumentZod>;
